import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { filtersCustomConfigMap, commercialSuppliersFilterId } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { config } from '@Constants/rx-ui/constants';

const withBarChartFilterPropsMap = (Component) => {
  function BarChartFilterPropsMapHOC(props) {
    const { filter } = props;
    const mappedProps = useMemo(() => {
      const groups = filter.get('groups');
      const groupCount = filter.get('groupCount');
      const thesaurus = filter.get('thesaurus');
      const userInputOpen = filter.get('userInputOpen');
      const id = filter.get('id');
      const isCommercialSuppliers = id === commercialSuppliersFilterId;
      const isThesaurus = Boolean(thesaurus);
      const customFilterConfig = filtersCustomConfigMap[filter.get('id')];

      return {
        isThesaurus,
        customFilterConfig,
        canRenderViewMore:
          isThesaurus || (isCommercialSuppliers && groupCount >= config.FILTER_MAX_GROUP_COUNT) || groups?.count() !== groupCount,
        disableViewMore: Boolean(userInputOpen),
        disableUserInputToggler: groups?.some((item) => item.get('selected')),
      };
    }, [filter]);

    return <Component {...props} {...mappedProps} />;
  }

  BarChartFilterPropsMapHOC.propTypes = {
    filter: PropTypes.instanceOf(Map).isRequired,
  };

  return BarChartFilterPropsMapHOC;
};

export default withBarChartFilterPropsMap;
